const DropDownItem = ({ children }) => (
  <div className="">
    {children}
  </div>
);

export default DropDownItem;
